module.exports = __webpack_public_path__ + "img/general-resource-mirror.3f764f83.png";